export default {
  packageCard: {
    Subscription: {
      month: '/月',
    },
    BuyNow: '今すぐ購入',
    permission: {
      ve: '動画制作',
      vrec: '画面録画ツール',
      insights: 'クリエイティブインサイト',
      gm: 'プレイアブル作成',
      assets: 'クリエイティブアセットライブラリ',
      packbuy: 'パッケージ追加プラン',
    },
    packageInfo: {
      validity: '有効期限1年',
      download: {
        amount: '合計{total}件',
      },
      mtgCharge: {
        noChange: '{baseMessage}{br}',
        change: '{baseMessage} プレイアブルダウンロード&プッシュ',
        notes: '(Mintegralプッシュ無制限)',
        notesTip: 'Mintegralチャンネル素材の送信回数に制限なし',
      },
      videoCredits: {
        amount: '合計{totalPoints}ポイント',
      },
    },
    download: {
      tabType: {
        subscription: 'プレイ可能なダウンロード&{br}プッシュ/月',
        normal: 'プレイ可能なダウンロード&{br}プッシュ',
      },
    },
    videoCredits: {
      tabType: {
        subscription: 'ポイント/月',
        normal: 'ポイント',
      },
    },
    storage: {
      amount: 'ストレージ容量',
      space: '{amount}G',
    },
    online: {
      amount: 'ログイン人数',
    },
    grantLabel: {
      hot: '人気',
      recommend: 'おすすめ',
    },
  },
  selectPackage: {
    title: '適切なパッケージを選択してください',
    tabType: {
      subscription: {
        quarter: '四半期サブスクリプション',
        annualized: '年間サブスクリプション（20%お得）',
      },
    },
    tabs: {
      tabType: {
        personal: '数量ごとに購入（個人用）',
        enterprise: '数量ごとに購入（企業用）',
        subscription: '期間ごとのサブスクリプション（企業用）',
      },
    },
    contract: {
      dialog: {
        title: 'パッケージを購入',
        message: '購入権限がありません。オンラインでお問い合わせください。',
      },
    },
    isEnterprise: {
      dialog: {
        message:
          'すでにサブスクリプションパッケージがあります。重複購入はできません。追加プランをご利用ください。',
        confirmbtn: '購入',
      },
    },
  },
  subscription: {
    package: {
      title: '追加プランを購入',
      description:
        '*1ヶ月は30日間。追加プラン：プレイアブルダウンロード/プッシュ$30/件、ポイント$100/5000、ストレージ200GBにアップグレード$100/月',
      tooltip: 'サブスクリプション後に購入可能',
      contact: {
        text: 'もっと必要ですか？企業向けのカスタムプランについてはお問い合わせください。',
        button: '今すぐ連絡',
      },
    },
  },
  record: {
    payment: {
      status: {
        pending: '支払い待ち',
        success: '支払完了',
        failed: '支払い失敗',
        canceled: 'キャンセルされました',
        warning: '支払い確認中',
      },
      statusTip: {
        warning:
          '第三者決裁サービスをご利用の場合、お支払いの確認に時間がかかる場合があります。お支払いの確認が取れ次第、システムが自動的にパッケージを有効化、またはアカウント残高にチャージを行います。',
      },
    },
    grantOrderType: {
      packBuy: '追加プランを購入',
      packageBuy: 'パッケージを購入',
      recharge: 'チャージ',
    },
    page: {
      title: '購入履歴',
      search: {
        preLabel: '支払い状況',
        placeholder: 'すべて',
      },
    },
    table: {
      name: '名前',
      tooltip: {
        downloadPush: 'プレイアブルダウンロード&プッシュ：{download_push}件',
        videoCredits: 'ポイント：{video_credits}',
      },
      bill: {
        amount: '請求金額',
      },
      operation: '操作',
      package: {
        validity: 'パッケージの有効期限',
      },
      update: {
        time: '更新日時',
      },
      payAgain: '再度支払い',
    },
    cancelPayment: {
      dialog: {
        title: '注文をキャンセル',
        message:
          'キャンセル後、この注文は再度支払うことができません。キャンセルを確認しますか？',
        confirmbtn: '確認',
        tip: 'キャンセル成功',
      },
    },
  },
  grantDialog: {
    partnerName: '顧客名',
    package: {
      info: '注文情報',
      firstTips:
        '個人プランを購入後、そのアカウントは企業プランの購入に使用できません。',
      validityDays: '有効期間：',
      amount: 'チャージ金額：',
    },
    packBuy: {
      info: '必要なコンテンツと数量を選択してください',
    },
    desc: 'この協力によって発生するすべての政府税、源泉徴収税、商品サービス税、付加価値税を含むがこれに限らない、はお客様の負担となります。',
    countTips: '必要な購入数量を選択してください',
    submit: '確認して支払いへ進む',
    minAmountTip: '最低金額 ${min_amount}',
    agree: 'Playturbo会員サービス規約を選択してください',
    partnerCodeTip: '顧客名を選択してください',
    amountTips: 'チャージ金額を入力してください',
    recharge: 'オンラインチャージ',
    packTable: {
      price: '単価',
      count: '数量',
      storageTips: 'ご契約のパッケージの有効期限はあと{quantity}か月です',
      amount: '価格',
      name: '名前',
      downloadPush: 'プレイ可能なダウンロード&プッシュを追加',
      renderVideo: 'ポイントを追加',
      storageUpgrade: 'ストレージを{storage}Gにアップグレード',
    },
    packageTable: {
      days: '{days}日',
    },
    totalFooter: {
      price: '価格（税抜き）',
    },
    downloadPushUnit: '{count}件',
    renderVideoUnit: '{count}ポイント',
    storageUnit: '{count}か月',
    amountTips2: '数字のみ入力可能です',
  },
  checkGrant: {
    success: '支払い完了',
    successMessage:
      '支払いが完了しました。注文ステータスの更新に遅れが生じる可能性がありますので、しばらくお待ちください。',
    successConfirm: '了解しました',
    failedMessage: '購入失敗',
  },
  router: {
    title: 'パッケージ購入',
  },
  profile: {
    form: {
      usertype: {
        title: 'アカウントタイプ',
        personal: '個人ユーザー',
        organization: '法人ユーザー',
      },
      contactQuestion: 'Playturboの法人ユーザーになりたいですか？',
      contactUs: 'お問い合わせ',
    },
  },
}
